import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  show(event) {
    const button = event.currentTarget
    const modal = document.getElementById('listing_modal')

    document.getElementById('listing_modal_id').textContent = button.dataset.listingId || 'n/a'
    document.getElementById('listing_modal_title').textContent =
      button.dataset.listingTitleRaw || 'Sem título'
    document.getElementById('listing_modal_type').textContent =
      button.dataset.listingPropertyType || 'n/a'
    document.getElementById('listing_modal_area').textContent =
      button.dataset.listingConstructedArea || 'n/a'
    document.getElementById('listing_modal_bedrooms').textContent =
      button.dataset.listingBedrooms || 'n/a'
    document.getElementById('listing_modal_bathrooms').textContent =
      button.dataset.listingBathrooms || 'n/a'
    document.getElementById('listing_modal_garage').textContent =
      button.dataset.listingGarage || 'n/a'
    document.getElementById('listing_modal_rental_price').textContent =
      button.dataset.listingRentalPrice || 'n/a'
    document.getElementById('listing_modal_admin_fee').textContent =
      button.dataset.listingAdministrationFee || 'n/a'
    document.getElementById('listing_modal_list_price').textContent =
      button.dataset.listingListPrice || 'n/a'
    document.getElementById('listing_modal_year_built').textContent =
      button.dataset.listingYearBuilt || 'n/a'
    document.getElementById('listing_modal_description').textContent =
      button.dataset.listingDescription || 'n/a'
    document.getElementById('listing_modal_list_date').textContent =
      button.dataset.listingListDate || 'n/a'
    document.getElementById('listing_modal_available').textContent =
      button.dataset.listingAvailableDate || 'n/a'
    document.getElementById('listing_modal_pub_type').textContent =
      button.dataset.listingPublicationType || 'n/a'
    document.getElementById('listing_modal_trans_type').textContent =
      button.dataset.listingTransactionType || 'n/a'
    document.getElementById('listing_modal_crm_id').textContent =
      button.dataset.listingCrmId || 'n/a'
    document.getElementById('listing_modal_tax').textContent = button.dataset.listingTax || 'n/a'
    document.getElementById('listing_modal_realtor_name').textContent =
      button.dataset.listingRealtorName || 'n/a'
    document.getElementById('listing_modal_realtor_email').textContent =
      button.dataset.listingRealtorEmail || 'n/a'
    document.getElementById('listing_modal_realtor_phone').textContent =
      button.dataset.listingRealtorPhone || 'n/a'

    const detailUrl = button.dataset.listingDetailUrl || '#'
    document.getElementById('listing_modal_link').innerHTML =
      '<a href="' + detailUrl + '" class="link" target="_blank">' + detailUrl + '</a>'

    modal.showModal()
  }
}
